// Errores de la baja de inventario → qué lee el operador y qué hace la pantalla.
// Los códigos vienen de `CardStockErrors.ts` de retail-cards-business.
import { ApiError, userMessageOf } from '@/api/errors';

export interface WriteOffErrorDecision {
    message: string;
    /**
     * La baja anterior con esa clave YA quedó asentada: el silo solo devuelve 409 cuando el
     * marcador existe y su asiento pide otra cantidad o motivo (el idéntico responde 200 replay).
     * La pantalla tiene que cerrar y releer el saldo, nunca invitar a reintentar.
     */
    alreadyApplied: boolean;
}

/** Mensaje y decisión de pantalla para el error de una baja de inventario. */
export function writeOffErrorMessage(error: unknown): WriteOffErrorDecision {
    const code = error instanceof ApiError ? error.code : null;

    if (code === 'WRITE_OFF_OPERATION_ID_REUSED') {
        return {
            message:
                'Esa baja ya quedó registrada con otra cantidad o motivo. Revisa el saldo antes de dar de baja otra vez.',
            alreadyApplied: true,
        };
    }
    if (code === 'INSUFFICIENT_CARD_STOCK') {
        return {
            message: 'Esta tienda no tiene tantas tarjetas disponibles. Revisa el saldo.',
            alreadyApplied: false,
        };
    }
    if (code === 'CARD_STOCK_NOT_FOUND') {
        return {
            message:
                'Esta tienda todavía no recibe ningún lote, así que no hay nada que dar de baja.',
            alreadyApplied: false,
        };
    }
    return { message: userMessageOf(error), alreadyApplied: false };
}
